/** Persistência da aba Tempo de Produção por Peça (IndexedDB). */

import type { RegistroTempoProducaoPecaLote } from './tempoProducaoPecaLote';

const DB_NAME = 'ade-tempo-producao-peca-db';
const DB_VERSION = 1;
const STORE = 'registros';
const KEY_TODOS = 'todos';

export type MapaRegistrosTempoProducaoPeca = Record<string, RegistroTempoProducaoPecaLote>;

function abrirDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function lerRegistrosTempoProducaoPeca(): Promise<MapaRegistrosTempoProducaoPeca> {
  try {
    const db = await abrirDb();
    const data = await new Promise<unknown>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(KEY_TODOS);
      req.onsuccess = () => resolve(req.result ?? null);
      req.onerror = () => reject(req.error);
    });
    db.close();
    if (!data || typeof data !== 'object') return {};
    return data as MapaRegistrosTempoProducaoPeca;
  } catch {
    return {};
  }
}

export async function salvarRegistrosTempoProducaoPeca(
  mapa: MapaRegistrosTempoProducaoPeca
): Promise<void> {
  const db = await abrirDb();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE).put(mapa, KEY_TODOS);
  });
  db.close();
}

export async function salvarRegistroTempoProducaoPecaLote(
  registro: RegistroTempoProducaoPecaLote
): Promise<void> {
  const mapa = await lerRegistrosTempoProducaoPeca();
  mapa[registro.loteChave] = registro;
  await salvarRegistrosTempoProducaoPeca(mapa);
}
